var BASWebServices;
(function (BASWebServices) {
    var Helper = (function () {
        function Helper() {
        }
        Helper.checkEncoding = function (file, dialog, scope) {
        };
        Helper.replaceAll = function (str, pattern, replace) {
            if (typeof (str) == "string") {
                return str.replace(new RegExp(pattern, 'g'), replace);
            }
            else {
                return str;
            }
        };
        return Helper;
    }());
    BASWebServices.Helper = Helper;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=Helper.js.map